var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SECOND_MS } from '../time';
var defaultReducer = {};
var FAILED_FETCH_UPDATE_TIMEOUT_DEFAULT = 10 * SECOND_MS;
export function shouldFetch(_a) {
    var fetchStatus = _a.fetchStatus, _b = _a.fetchTimeout, fetchTimeout = _b === void 0 ? 0 : _b, _c = _a.minUpdate, minUpdate = _c === void 0 ? 0 : _c, _d = _a.failedFetchUpdate, failedFetchUpdate = _d === void 0 ? FAILED_FETCH_UPDATE_TIMEOUT_DEFAULT : _d;
    var _e = fetchStatus || {}, fetchingInProgressSince = _e.fetchingInProgressSince, lastSuccessfulFetch = _e.lastSuccessfulFetch, didInvalidate = _e.didInvalidate, lastFailedFetch = _e.lastFailedFetch;
    if (!fetchingInProgressSince) {
        if (lastFailedFetch && Date.now() - lastFailedFetch < failedFetchUpdate) {
            return false;
        }
        // Should update if data is too old
        if (didInvalidate ||
            !lastSuccessfulFetch ||
            Date.now() - lastSuccessfulFetch > minUpdate) {
            return true;
        }
    }
    else if (fetchingInProgressSince &&
        Date.now() - fetchingInProgressSince > fetchTimeout) {
        // Ensure we cannot get stuck in fetchingInProgressSince=true state.
        return true;
    }
    return false;
}
export var isTooEarlyToUpdateRecentFailure = function (_a) {
    var lastFailedFetch = _a.lastFailedFetch, lastSuccessfulFetch = _a.lastSuccessfulFetch, fetchingInProgressSince = _a.fetchingInProgressSince;
    return !!lastFailedFetch &&
        lastFailedFetch > (lastSuccessfulFetch !== null && lastSuccessfulFetch !== void 0 ? lastSuccessfulFetch : 0) &&
        !fetchingInProgressSince;
};
// eslint-disable-next-line import/prefer-default-export
export var createReducer = function (name, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.extendedReducer, extendedReducer = _c === void 0 ? defaultReducer : _c, _d = _b.minUpdate, minUpdate = _d === void 0 ? 0 : _d, _e = _b.failedFetchUpdate, failedFetchUpdate = _e === void 0 ? FAILED_FETCH_UPDATE_TIMEOUT_DEFAULT : _e, _f = _b.fetchTimeout, fetchTimeout = _f === void 0 ? 0 : _f, initialState = _b.initialState, _g = _b.invalidateActions, invalidateActions = _g === void 0 ? [] : _g, _h = _b.resetActions, resetActions = _h === void 0 ? [] : _h, _j = _b.initialItems, initialItems = _j === void 0 ? {} : _j;
    var actions = {
        FETCH_IN_PROGRESS: "FETCH_".concat(name, "_IN_PROGRESS"),
        FETCH_SUCCESSFUL: "FETCH_".concat(name, "_SUCCESSFUL"),
        FETCH_FAILED: "FETCH_".concat(name, "_FAILED"),
        INVALIDATE: "INVALIDATE_".concat(name),
    };
    // @ts-ignore initialState should be defined when TAdditionalState != undefined
    var INITIAL_STATE = __assign({ fetchingInProgressSince: null, lastSuccessfulFetch: null, lastFailedFetch: null, didInvalidate: false, items: initialItems }, initialState);
    var reducer = function (oldState, action) {
        if (oldState === void 0) { oldState = INITIAL_STATE; }
        if (action === void 0) { action = { type: undefined }; }
        var state = resetActions.includes(action.type) ? INITIAL_STATE : oldState;
        state = invalidateActions.includes(action.type)
            ? __assign(__assign({}, state), { didInvalidate: true }) : state;
        if (extendedReducer === null || extendedReducer === void 0 ? void 0 : extendedReducer[action.type]) {
            return extendedReducer === null || extendedReducer === void 0 ? void 0 : extendedReducer[action.type](state, action);
        }
        switch (action.type) {
            case actions.FETCH_IN_PROGRESS:
                return __assign(__assign({}, state), { fetchingInProgressSince: action.timestamp, fetchPromise: action.fetchPromise });
            case actions.FETCH_SUCCESSFUL:
                return __assign(__assign({}, state), { items: action.items, fetchingInProgressSince: null, lastSuccessfulFetch: action.timestamp, fetchPromise: null, didInvalidate: false });
            case actions.FETCH_FAILED:
                return __assign(__assign({}, state), { fetchingInProgressSince: null, lastFailedFetch: action.timestamp, fetchPromise: null });
            case actions.INVALIDATE:
                return __assign(__assign({}, state), { didInvalidate: true });
            default:
                return state;
        }
    };
    reducer.INITIAL_STATE = INITIAL_STATE;
    reducer.actions = actions;
    reducer.invalidate = function () { return ({
        type: actions.INVALIDATE,
    }); };
    reducer.fetchSuccessful = function (items) { return ({
        type: actions.FETCH_SUCCESSFUL,
        items: items,
        timestamp: Date.now(),
    }); };
    reducer.fetchFailed = function (reason) { return ({
        type: actions.FETCH_FAILED,
        reason: reason,
        timestamp: Date.now(),
    }); };
    reducer.fetchInProgress = function (fetchPromise) { return ({
        type: actions.FETCH_IN_PROGRESS,
        fetchPromise: fetchPromise,
        timestamp: Date.now(),
    }); };
    reducer.shouldFetch = function (currentState) {
        return shouldFetch({
            fetchStatus: currentState,
            fetchTimeout: fetchTimeout,
            failedFetchUpdate: failedFetchUpdate,
            minUpdate: minUpdate,
        });
    };
    return reducer;
};
